import ApiCore from './api-core'
import { DRIVER } from '@/constants/api-types'

export default class LoadTemporary extends ApiCore {
  constructor(store) {
    const path = `${DRIVER}/order/temporary`
    super(store, path)
  }

  report(filter, showProgress) {
    return this.request({
      action: 'report',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  accept(id, showProgress) {
    return this.request({
      action: `${id}/accept`,
      method: 'PATCH',
      showProgress
    })
  }
}
